import { memo } from 'react';
import { useTitle } from 'hoofd';

export const PageTitle = memo(({ title }: { title: string }) => {
    useTitle(title);
    return null;
});
